import ScrapePartnerProductButton from "./components/ScrapePartnerProductButton";

export default ScrapePartnerProductButton;
